let timeout;

let search_input = document.querySelector('#main-search .main-search__input');
let search_results = document.querySelector('.main-search__results');

function search_products(q) {
	if (q.length < 3) return;

	fetch(
		(typeof Shopify !== 'undefined' ? Shopify.routes.root : '/') +
		'search/suggest?q=' + q + '&resources[type]=product&resources[limit]=4&section_id=predictive_search'
	)
	.then( r => {
		if (!r.ok) {
			let error = new Error(r.status);
			throw error;
		}

		return r.text();
	} )
	.then( h => {
		let div = document.createElement('div');

		div.innerHTML = h;
		search_results.innerHTML = div.querySelector('.shopify-section').innerHTML;

		search_results.classList.add('loaded');
	} );
}


if (search_input) {
	search_input.addEventListener( 'input', e => {
		search_results.classList.remove('loaded');
		clearTimeout(timeout);

		let query = e.currentTarget.value.trim();

		timeout = setTimeout(
			() => {
				search_products(query);
				gtag( 'event', 'search', { search_term: query } ); // tracking
			},
			300
		);
	} );
}